import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
	AccessCodeExistsGuard,
	AccessCodeNotFoundExistsGuard,
	HasCodeGuard,
	HasForgotPasswordGuard,
	HasResetCodeGuard,
	IfAuthorizedGuard,
	IfNotLoggedInGuard,
	IfRegistrationCodeSuccessGuard,
	IfRegistrationContractSuccessGuard
} from '@spaq/core/guards';
import { HasAccessCodeGuard } from '@spaq/core/guards/has-access-code.guard';
import { HasContractNotPaidGuard } from '@spaq/core/guards/has-contract-not-paid.guard';
import { HasContractPaidGuard } from '@spaq/core/guards/has-contract-paid.guard';
import { HasContractGuard } from '@spaq/core/guards/has-contract.guard';
import { HasNoContractGuard } from '@spaq/core/guards/has-no-contract.guard';
import { HasNoSubscriptionGuard } from '@spaq/core/guards/has-no-subscription.guard';
import { HasRemainingStepsGuard } from '@spaq/core/guards/has-remaining-steps.guard';
import { HasSubscriptionGuard } from '@spaq/core/guards/has-subscription.guard';
import { IsAdminGuard } from '@spaq/core/guards/is-admin.guard';
import { IsEmailVerifiedGuard } from '@spaq/core/guards/is-email-verified.guard';
import { IsLoggedInGuard } from '@spaq/core/guards/is-logged-in.guard';
import { IsNotLoggedInGuard } from '@spaq/core/guards/is-not-logged-in.guard';
import { IsPublicGuard } from '@spaq/core/guards/is-public.guard';
import { IsVerifiedGuard } from '@spaq/core/guards/is-verified.guard';
import { LoginEmailGuard } from '@spaq/core/guards/login-email.guard';
import { RegistrationCompletedGuard } from '@spaq/core/guards/registration-completed.guard';

@NgModule({
	declarations: [],
	imports: [CommonModule],
	providers: [
		HasRemainingStepsGuard,
		HasNoSubscriptionGuard,
		HasContractGuard,
		HasNoContractGuard,
		HasContractNotPaidGuard,
		HasContractPaidGuard,
		LoginEmailGuard,
		IsVerifiedGuard,
		IsNotLoggedInGuard,
		IsPublicGuard,
		IsLoggedInGuard,
		IsAdminGuard,
		IsEmailVerifiedGuard,
		RegistrationCompletedGuard,
		HasSubscriptionGuard,
		HasAccessCodeGuard,
		IfAuthorizedGuard,
		AccessCodeExistsGuard,
		AccessCodeNotFoundExistsGuard,
		HasForgotPasswordGuard,
		HasResetCodeGuard,
		HasCodeGuard,
		IfRegistrationCodeSuccessGuard,
		IfNotLoggedInGuard,
		IfRegistrationContractSuccessGuard
	]
})
export class CoreGuardModule {}
